
import { motion } from 'framer-motion';

export default function CoreValueSection() {
  const values = [
    {
      number: '01',
      icon: 'ri-shield-check-line',
      title: '재해예방 솔루션 제공',
      subtitle: '전문가적 전문성 지향',
      description:
        '건설현장의 특성을 정확히 파악하고, 현장 맞춤형 재해예방 솔루션을 제공합니다. 풍부한 경험과 전문성을 바탕으로 실질적인 안전관리 체계를 구축합니다.',
    },
    {
      number: '02',
      icon: 'ri-settings-3-line',
      title: '스마트 안전관리',
      subtitle: '지속가능한 안전시스템 구축',
      description:
        '최신 기술과 체계적인 관리 시스템을 통해 지속 가능한 안전 환경을 조성합니다. 예방 중심의 선제적 안전관리로 건설현장의 안전문화를 정착시킵니다.',
    },
  ];

  return (
    <section id="core-value" className="py-16 sm:py-20 lg:py-28 bg-[#f5f7fa]">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-6">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-10 sm:mb-16"
        >
          <div className="text-[#ff6b35] text-xs font-semibold tracking-[0.2em] mb-2 sm:mb-3">
            CORE VALUE
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-[#1a2b4a]">핵심가치</h2>
        </motion.div>

        {/* Value Cards */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 sm:gap-10">
          {values.map((value, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              whileHover={{ y: -8 }}
              className="relative bg-white rounded-2xl sm:rounded-3xl p-6 sm:p-10 shadow-lg hover:shadow-2xl transition-all duration-300 cursor-pointer overflow-hidden"
            >
              {/* Number */}
              <div className="absolute top-6 sm:top-8 right-6 sm:right-8 text-5xl sm:text-7xl font-bold text-[#1a2b4a]/5">
                {value.number}
              </div>

              {/* Icon */}
              <div className="w-16 h-16 sm:w-24 sm:h-24 bg-[#ff6b35]/10 rounded-full flex items-center justify-center mb-4 sm:mb-6">
                <i className={`${value.icon} text-[#ff6b35] text-3xl sm:text-5xl`}></i>
              </div>

              {/* Content */}
              <h3 className="text-xl sm:text-2xl lg:text-3xl font-bold text-[#1a2b4a] mb-2 sm:mb-3">
                {value.title}
              </h3>
              <p className="text-base sm:text-lg lg:text-xl text-gray-600 font-medium mb-3 sm:mb-5">
                {value.subtitle}
              </p>
              <p className="text-sm sm:text-base text-gray-600 leading-relaxed">{value.description}</p>

              {/* Accent */}
              <div className="absolute bottom-0 left-0 w-20 h-20 sm:w-32 sm:h-32 bg-[#ff6b35]/5 rounded-tl-3xl rounded-br-3xl"></div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
